import React, {Component} from 'react';
import "./GuideMp.scss"
import guide01 from "../../static/img/guide_01.png"
import guide02 from "../../static/img/guide_02.png"
import guide03 from "../../static/img/guide_03.png"
import guide04 from "../../static/img/guide_04.png"
import guide05 from "../../static/img/guide_05.png"
import guide06 from "../../static/img/guide_06.png"

class GuideMp extends Component {

    render() {
        return (
            <div className="guide">
                <img src={guide01} alt=""/>
                <img src={guide02} alt=""/>
                <img src={guide03} alt=""/>
                <img src={guide04} alt=""/>
                <img src={guide05} alt=""/>
                <img src={guide06} alt=""/>
            </div>
        );
    }
}

export default GuideMp;
